type DateValue = Date | string | number | {valueOf: () => number} | null | undefined;

type BookingRestrictionActivationInput = {
    activeWithoutTimeFrame: boolean;
    startDateTime?: DateValue;
    endDateTime?: DateValue;
    membersOnly?: boolean;
    hasPrerequisiteCourses?: boolean;
    expireAction?: string | null;
    currentDate?: Date;
};

const toDate = (value: DateValue): Date | undefined => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (value instanceof Date) {
        return value;
    }
    if (typeof value === "object") {
        return new Date(value.valueOf());
    }

    return new Date(value);
};

/**
 * `active` historically has two meanings: without dates it is the persisted
 * enable/disable flag, while dated restrictions were derived by the admin UI.
 * Re-derive dated rows so already stored UI values remain backward-compatible.
 */
export const deriveBookingRestrictionActive = ({
    activeWithoutTimeFrame,
    startDateTime,
    endDateTime,
    membersOnly = false,
    hasPrerequisiteCourses = false,
    expireAction,
    currentDate = new Date(),
}: BookingRestrictionActivationInput): boolean => {
    const start = toDate(startDateTime);
    const end = toDate(endDateTime);

    if (!start && !end) {
        return activeWithoutTimeFrame;
    }

    const isWithinTimeFrame = (!start || start <= currentDate) && (!end || end >= currentDate);
    const hasAudienceRestriction = membersOnly || hasPrerequisiteCourses;

    return (isWithinTimeFrame && hasAudienceRestriction) || (!isWithinTimeFrame && expireAction === "HideFromAll");
};
